<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <Header />
    <HeaderResponsive />
    <div class="container container_boletines">
      <SecondHeader />
      <p class="title_section">Boletines Agroclimáticos</p>

      <div class="row boletin">
        <div class="col-md-3 col-sm-12" style="word-wrap:break-word" v-for="({fileLink, fileTitle},index) in this.items">
         
          <!--<a :href="fileLink"> {{`Boletín ${index + 1}`}}       <font-awesome-icon class icon="download" :style="{ color: 'red' }" /></a>-->
          <a :href="fileLink"> <font-awesome-icon class icon="download" :style="{ color: 'red', float: 'left', marginRight: '10px' }" />       {{fileTitle}}</a>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>



<script>
import Header from "./partials/Header";
import SecondHeader from "./partials/SecondHeader";
import HeaderResponsive from "./partials/HeaderResponsive";
import Footer from "./partials/Footer";
import axios from "axios";

import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import config from '../../helpers/config';

export default {
  mounted() {
    this.getBoletines();
  },
  components: {
    Header,
    SecondHeader,
    HeaderResponsive,
    Footer,
    Loading
  },
  data() {
    return {
      items: [],
      isLoading: false,
      fullPage: true
    };
  },
  methods: {
    getBoletines() {
      this.isLoading = true;
      axios
        .get(`${config.urlApi}/boletins?filter[where][state]=1`, {})
        .then(response => {
          this.items = response.data;
          this.isLoading = false;
        })
        .catch(function(error) {
          ////console.log(error)
        });
    }
  }
};
</script>


<style>
.title_section {
  color: #3366cc;
  font-weight: bolder;
  font-size: 2em;
}
.boletin {
  margin-top: 40px;
}
.boletin > .col-md-4,
.boletin > .col-sm-12 {
  margin-bottom: 25px !important;
}

@media (max-width: 768px) {
  .title_section {
    margin-top: 40px !important;
    text-align: center;
  }
  .container > p {
    line-height: 1 !important;
  }
  .boletin {
    text-align: center;
    margin-left: -20px !important;
  }
}
</style>
